import $ from '@rover/globals/jquery';
import _ from '@rover/globals/underscore';
import Backbone from '@rover/globals/backbone';
import Mustache from '@rover/globals/Mustache';
import CreditCardView from './credit_card_view';

export default Backbone.View.extend({
  template: Mustache.template('new_design/account_conversations/creditcard_list'),
  events: {
    'click input[name="cc"]': 'triggerCardSelected',
  },
  initialize() {
    _.bindAll(this, 'render', 'add', 'ensureCardSelected');
    this.rendered = false;
    this.listenTo(this.collection, 'reset', this.render);
    this.listenTo(this.collection, 'add', this.add);
    this.on('cardRemoved', this.ensureCardSelected, this);
  },
  isRendered() {
    return this.rendered;
  },
  getSelectedCC() {
    return this.$('.js-creditcard:checked');
  },
  getSelectedCCURL() {
    return this.getSelectedCC().val() || false;
  },
  ensureCardSelected() {
    if (!this.getSelectedCC().length) {
      this.$('.js-creditcard:last').prop('checked', true);
      this.triggerCardSelected();
    }
  },
  triggerCardSelected() {
    this.trigger('cardSelected');
  },
  add(card) {
    const $newContainer = $('<div class="js-creditcard-container"></div>');
    const ccView = new CreditCardView({
      model: card,
      el: $newContainer,
      collectionView: this,
    });

    const data = card.toJSON();
    data.notFirst = this.$('.js-creditcard-container').length > 0;
    if (data.default_payment) {
      this.getSelectedCC().prop('checked', false);
      this.$('.js-creditcard.js-default-payment').removeClass('js-default-payment');
    }
    this.$('.js-creditcard-list').append($newContainer);

    ccView.render(data);

    this.$('.js-creditcard-list').show();
    this.trigger('rendered');
    this.triggerCardSelected();
  },
  render() {
    this.$el.html(this.template.render());

    if (!this.collection.models.length) {
      this.rendered = true;
      this.trigger('initialRender');
      return;
    }

    this.$('.js-creditcard-list').empty();

    this.collection.models.forEach(card => {
      this.add(card);
    });

    this.ensureCardSelected();

    this.rendered = true;

    this.trigger('initialRender');
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/checkout/credit_card_collection_view.js